import { HomePage, TasksPage, ProfilePage, MyGPTs, OutlookAddinPage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/tasks',
        element: TasksPage
    },
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home/:conversationId?',
        element: HomePage
    },
    {
        path: '/my-gpts/:gptId?',
        element: MyGPTs
    },
    {
        path: '/outlook-addin',
        element: OutlookAddinPage
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
